import React, { useEffect } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getTerms as getTermsSelector } from '@verzekeringapp-mono/shared/src/state/selectors/terms'
import { useTerms } from '@verzekeringapp-mono/shared/src/hooks/use_terms'

const TermsOfUseScreen: React.FC = () => {
  const { getTerms } = useTerms()

  const terms = useAppSelector(getTermsSelector)

  useEffect(() => {
    getTerms()
  }, [])

  return (
    <ScreenWrapper>
      <div className='w-full rounded bg-surface-page p-8'>
        {terms
          ? (
            <div
              className='html-content p-4'
              dangerouslySetInnerHTML={{ __html: terms?.content }}
            />
          )
          : (
            <p>Laden...</p>
          )}
      </div>
    </ScreenWrapper>
  )
}

export default TermsOfUseScreen
